/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_LinksInputs */

const vi_shop_group_links = /** @type {(inputs: Shop_Group_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên kết`)
};

/**

* @param {Shop_Group_LinksInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_links = /** @type {((inputs?: Shop_Group_LinksInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_LinksInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_links(inputs)
});